import { PATTERN_FENCE_ID, PATTERN_FENCE_TOP_ID } from 'game/defs/PatternFence';

export const FenceFrontLeftSprite = (
  <>
    <rect x={27} y={22} width={2200} height={338} fill={`url(#${PATTERN_FENCE_ID})`} />

    <path
      fill="#b3b3b3"
      stroke="#666"
      strokeWidth="4"
      d="M1487 17h20v351a9.73 9.73 0 01-9.73 9.73h-.53A9.73 9.73 0 011487 368V17h0zM1512 17a15 15 0 00-30 0zM747 17h20v351a9.73 9.73 0 01-9.73 9.73h-.53A9.73 9.73 0 01747 368V17h0zM772 17a15 15 0 00-30 0zM2227 17h20v351a9.73 9.73 0 01-9.73 9.73h-.53A9.73 9.73 0 012227 368V17h0zM2252 17a15 15 0 00-30 0z"
    />
    <path
      fill="#b3b3b3"
      stroke="#666"
      strokeWidth="4"
      d="M1507 42H2227V61.46H1507z"
    />
    <path
      fill="#b3b3b3"
      stroke="#666"
      strokeWidth="4"
      d="M767 42H1487V60.95H767z"
    />
    <path
      fill="#b3b3b3"
      stroke="#666"
      strokeWidth="4"
      d="M7 17h20v351a9.73 9.73 0 01-9.73 9.73h-.53A9.73 9.73 0 017 368V17h0zM32 17a15 15 0 00-30 0z"
    />
    <path
      fill="#b3b3b3"
      stroke="#666"
      strokeWidth="4"
      d="M27 42H747V60.95H27z"
    />
    <rect
      width="639"
      height="229"
      x="807.5"
      y="92.5"
      fill="#fcee21"
      rx="1.5"
    />
    <path d="M1445 93a1 1 0 011 1v226a1 1 0 01-1 1H809a1 1 0 01-1-1V94a1 1 0 011-1h636m0-1H809a2 2 0 00-2 2v226a2 2 0 002 2h636a2 2 0 002-2V94a2 2 0 00-2-2z" />
    <rect
      width="639"
      height="229"
      x="1547.5"
      y="92.5"
      fill="#fcee21"
      rx="1.5"
    />
    <path d="M2185 93a1 1 0 011 1v226a1 1 0 01-1 1h-636a1 1 0 01-1-1V94a1 1 0 011-1h636m0-1h-636a2 2 0 00-2 2v226a2 2 0 002 2h636a2 2 0 002-2V94a2 2 0 00-2-2z" />
    <rect
      width="639"
      height="229"
      x="67.5"
      y="92.5"
      fill="#fcee21"
      rx="1.5"
    />
    <path d="M705 93a1 1 0 011 1v226a1 1 0 01-1 1H69a1 1 0 01-1-1V94a1 1 0 011-1h636m0-1H69a2 2 0 00-2 2v226a2 2 0 002 2h636a2 2 0 002-2V94a2 2 0 00-2-2z" />
    <text
      fontFamily="Impact"
      fontSize="188.25"
      transform="translate(855.14 282)"
    >
      SECRET
    </text>
    <text
      fontFamily="Impact"
      fontSize="188.25"
      letterSpacing=".02em"
      transform="translate(1729.07 282)"
    >
      LAB
    </text>
    <text
      fontFamily="Impact"
      fontSize="188.25"
      transform="translate(244.94 282)"
    >
      TOP
    </text>

  </>
);

export const FenceTopSprite = (
  <rect width={11} height={600} fill={`url(#${PATTERN_FENCE_TOP_ID})`} />
);

export const FencePostSprite = (
  <path
    fill="#b3b3b3"
    stroke="#666"
    strokeWidth="4"
    d="M7 17h20v351a9.73 9.73 0 01-9.73 9.73h-.53A9.73 9.73 0 017 368V17h0zM32 17a15 15 0 00-30 0z"
  />
);

export const FenceRightSprite = (
  <>
    <rect x={27} y={22} width={1460} height={338} fill={`url(#${PATTERN_FENCE_ID})`} />
    <path
      fill="#b3b3b3"
      stroke="#666"
      strokeWidth="4"
      d="M747 17h20v351a9.73 9.73 0 01-9.73 9.73h-.53A9.73 9.73 0 01747 368V17h0zM772 17a15 15 0 00-30 0zM7 17h20v351a9.73 9.73 0 01-9.73 9.73h-.53A9.73 9.73 0 017 368V17h0zM32 17a15 15 0 00-30 0zM1487 17h20v351a9.73 9.73 0 01-9.73 9.73h-.53A9.73 9.73 0 011487 368V17h0zM1512 17a15 15 0 00-30 0z"
    />
    <path
      fill="#b3b3b3"
      stroke="#666"
      strokeWidth="4"
      d="M767 42H1487V61.46H767z"
    />
    <path
      fill="#b3b3b3"
      stroke="#666"
      strokeWidth="4"
      d="M27 42H747V60.95H27z"
    />
  </>
);
